import { canv } from '@/canv/global.js'
import { escapeString, reverseTransformPoint } from '@/canv/utils.js';
import { getFirstSelected } from "@/canvasController/helpers";

export class linkWidgetMenuWindow {

    constructor() {

    }


    show(currentLink, textWidget, extraUpdate = null) {
        this.hide();

        this.textWidget = textWidget;
        this.extraUpdate = extraUpdate;

        var linkWidgetMenuWindow = document.createElement('div');
        document.body.prepend(linkWidgetMenuWindow);

        linkWidgetMenuWindow.classList.add("linkWidgetMenuWindow");
        linkWidgetMenuWindow.classList.add("dragThrowAble");
        linkWidgetMenuWindow.innerHTML = this.getBar();

        var linkWidgetMenuWindowInput = document.getElementsByClassName("linkWidgetMenuWindowInput")[0];
        linkWidgetMenuWindowInput.value = currentLink;
        setTimeout(() => { linkWidgetMenuWindowInput.focus() }, 0);
        this.locate();
        this.init();
    }

    hide() {

        var linkWidgetMenuWindow = document.getElementsByClassName("linkWidgetMenuWindow")[0];

        if (linkWidgetMenuWindow != undefined) {
            linkWidgetMenuWindow.outerHTML = "";
        }

        this.textWidget = null;
        this.extraUpdate = null;
    }

    locate() {
        const selectedProps = canv.canvasController.getSelectedProps();

        var startX = selectedProps["startX"];
        var startY = selectedProps["startY"];
        var width = selectedProps["width"];

        var menu = document.getElementsByClassName("linkWidgetMenuWindow")[0];
        if (menu == undefined) {
            return;
        }

        if (menu.style.opacity == "0") {
            menu.style.opacity = "1";
            menu.style.marginTop = "0px";
        }

        var menuSize = menu.getBoundingClientRect();

        var xTarget = (startX + width / 2) * canv.m[0];
        var yTarget = startY * canv.m[3];

        const cursorTool = canv.toolBox.TryGetToolByName("cursorTool");

        // всегда true, так linkWidgetMenuWindow это часть интерфейса textWidget при interaction
        if (cursorTool.isMode("interaction")) {
            const interactionLocale = getFirstSelected().locateWidgetMenu();
            if (interactionLocale["status"]) {
                xTarget = interactionLocale["x"] * canv.m[3];
                yTarget = interactionLocale["y"] * canv.m[3];
            }
        }

        var pt = reverseTransformPoint(xTarget, yTarget);

        var wantedX = pt.x - menuSize.width / 2;
        if (wantedX < 10) wantedX = 10;
        if (wantedX + menuSize.width + 10 > canv.canvas.getBoundingClientRect().width) wantedX = canv.canvas.getBoundingClientRect().width - menuSize.width - 10;
        menu.style.left = (wantedX).toString() + "px";

        var gap = 50; //  было 25
        var wantedY = pt.y - menuSize.height - gap;
        if (wantedY < 60) wantedY = 60;
        if (wantedY + menuSize.height + 10 > canv.canvas.getBoundingClientRect().height) wantedY = canv.canvas.getBoundingClientRect().height - menuSize.height - 10;
        menu.style.top = (wantedY).toString() + "px";
    }

    init() {

        var linkWidgetMenuWindowInput = document.getElementsByClassName("linkWidgetMenuWindowInput")[0];

        linkWidgetMenuWindowInput.addEventListener('focus', this.inputFocus.bind(this), false);
        linkWidgetMenuWindowInput.addEventListener('blur', this.inputBlur.bind(this), false);
        linkWidgetMenuWindowInput.addEventListener('keydown', this.inputKeyPress.bind(this), false);

    }


    // listeners

    inputFocus(e) {
        canv.appInterface.inputFocused = 1;
    }

    inputBlur(e) {
        canv.appInterface.inputFocused = 0;
    }

    inputKeyPress(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();

            var linkWidgetMenuWindowInput = document.getElementsByClassName("linkWidgetMenuWindowInput")[0];

            const link = linkWidgetMenuWindowInput.value;
            this.textWidget.menuLinkSet(this.prepareLink(link));
            if (this.extraUpdate != null) {
                // linkSet - это внутренняя механика textWidget, которая меняет его dimensions. Например, как при paste. Но если сигнал о paste передается через TryAction
                // и виджет (parent-widget), частью которого является этот textWidget, просто вызывает updateDims после TryAction, то после вызова menuLinkSet parent-widget
                // ничего об это не узнает. Поэтому делаем callback
                this.extraUpdate();
            }
            this.hide();
            canv.appInterface.inputFocused = 2;
            //e.preventDefault(); // так тоже работает
        }
    }

    // tools

    prepareLink(rawText) {
        let link = rawText;

        if (rawText !== "" && !link.startsWith("https://") && !link.startsWith("http://") && !link.startsWith("file://")) {
            link = "https://" + link;
        }

        return escapeString(link);
    }





    // templates

    getBar() {
        return `
            <input type="text" class="linkWidgetMenuWindowInput" placeholder="Введите ссылку и нажмите Enter">
        `;
    }

    textWidget = null;
    extraUpdate = null;

}
